import { MailboxSearchList } from '../Components/Mailbox/MailboxSearchList';

function MailboxesSearch() {
	return <MailboxSearchList />;
}

export default MailboxesSearch;
